<template>
  <el-card shadow="never" class="l-main-card">
    <div class="l-table-toolbar">
      <div class="flex items-center justify-between">
        <div class="flex items-center">
          <!-- <p>场所类型：</p> -->
          <el-row>
            <!-- <el-button type="info" :class="{active:search_data.type==''?true:false}" plain @click="placetype('')" v-model="search_data.type">全部</el-button> -->
            <!-- <el-button type="info" :class="{active:search_data.place_type==item.id?true:false}" plain v-for="item in place_type_list" :key="item.id" @click="placetype(item.id)" v-model="search_data.type" v-show="item.id!=1">{{item.name}}</el-button> -->
          </el-row>
        </div>
      </div>
      <div class="ivu-mt">
        <l-auth-button type="primary" auth="department_add_btn" @click="add_visible = true"> 添加 </l-auth-button>
        <!-- <div class="l-simple-search-container">
        <el-input placeholder="请输入查找内容" v-model="search_data.name" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
        </el-input>
      </div> -->
      </div>
    </div>
    <l-table :data="data" v-loading="loading" row-key="id">
      <el-table-column fixed prop="index" label="序号" width="100"> </el-table-column>

      <el-table-column prop="is_public" label="是否为公共" min-width="80">
        <template slot-scope="{ row }">
           <el-tag type="success" disable-transitions v-if="row.is_public == 1">{{ IS_PUBLIC[row.is_public] }}</el-tag>
          <el-tag type="danger" disable-transitions v-else-if="row.is_public == 2">{{ IS_PUBLIC[row.is_public] }}</el-tag>
        </template>
      </el-table-column>


      <el-table-column prop="place_type_name" label="私有归属场所类型" min-width="80"></el-table-column>

      <el-table-column prop="name" label="街道和社区名称" min-width="100">
        <template slot-scope="{ row }">
          <a style="color: cornflowerblue;" v-if="row.type == 3 || row.type == 4" @click="showInfo(row.id)">{{row.name}}</a>
          <a size="small" v-else disable-transitions>{{row.name}}</a>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型" min-width="80">
        <template slot-scope="{ row }">
          <p>{{lavel_name(row.type)}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="is_node" label="是否为节点" min-width="80">
        <template slot-scope="{ row }">
          <p>{{row.is_node==0?'否':'是'}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="abbreviation" label="缩写" min-width="80"> </el-table-column>
      <el-table-column prop="created_at" label="创建时间" width="180"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="150" align="center">
        <template slot-scope="{ row }">
          <l-auth-text-button type="primary" auth="department_edit_btn" @click="showEdit(row.id)"><i class="el-icon-edit"></i>编辑</l-auth-text-button>
          <span class="l-action-separator">|</span>
          <l-auth-text-button type="danger" auth="department_del_btn" @click="del(row.id)"><i class="el-icon-delete"></i>删除</l-auth-text-button>
        </template>
      </el-table-column>
    </l-table>

    <!--分页-->
    <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size" :current-page.sync="page"></l-page>

    <!--添加-->
    <l-dialog :visible.sync="add_visible" title="添加街道社区部门" width="1100px">
      <l-department-edit @on-success="onAddSucess" :visible.sync="add_visible" :place_type="place_type"></l-department-edit>
    </l-dialog>

    <!--详情-->
    <l-dialog :visible.sync="info_visible" title="社区责任人管理" width="1400px">
      <l-department-info @on-success="onAddSucess" :visible.sync="info_visible" :id="community_id"></l-department-info>
    </l-dialog>

    <!--编辑-->
    <l-dialog :visible.sync="edit_visible" title="编辑街道社区部门" width="1000px">
      <l-department-edit @on-success="onEditSucess" :visible.sync="edit_visible" :id="edit_id"></l-department-edit>
    </l-dialog>
  </el-card>
</template>

<script>

import Edit from "./Edit.vue";
import Info from "./Info.vue";
import {
  getName,IS_PUBLIC
} from './lavel.js';

import Vue from "vue";
export default {
  components: {
    [Edit.name]: Edit,
    [Info.name]: Info,

  },
  data() {
    return {
      data: [],
      count: 0,
      page: 1,
      page_size: Vue.$_config.page.page_size,
      loading: false,
      // place_type_list:JSON.parse(store.get("place_type_list")),
      export_loading: false,
      change_state_loading: [],

      add_visible: false, //是否显示添加
      edit_visible: false, //是否显示编辑
      info_visible: false,  //获取责任人
      edit_id: 0,
      info_id: 0,
      community_id: 0,
      place_type: '',
IS_PUBLIC:IS_PUBLIC,
      //搜索
      search_visible: false,
      search_data: {
        name: "",
        place_type: ''
      },
      rel_search_data: {},
      show_more_search: false,
    };
  },
  computed: {
    place_type_list() {
      return this.$store.state.list.place_type_list
    },

  },

  mounted() {
    this.getList();
  },

  methods: {
    lavel_name(value) {
      return getName(value)
    },
    //获取数据
    getList() {
      this.loading = true;
      this.rel_search_data = this.search_data;
      this.$_invoke("communitySector_getList", {
        page: this.page,
        page_size: this.page_size,
        ...this.rel_search_data,
      })
        .then((ret) => {
          this.data = ret.data;
          this.count = ret.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //通过类型筛选
    // placetype(id) {
    //   this.search_data.place_type = id;
    //   this.place_type = id;
    //   this.rel_search_data = this.search_data;
    //   this.getList();
    // },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    //页码改变
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    //每页显示条数改变
    pageSizeChange(page_size) {
      this.page_size = page_size;
      this.getList();
    },
    //添加成功回调
    onAddSucess() {
      this.add_visible = false;
      this.getList();
    },

    //显示修改界面
    showEdit(id) {
      this.edit_id = id;
      this.$nextTick(() => {
        this.edit_visible = true;
      });
    },

    //编辑成功回调
    onEditSucess() {
      this.edit_visible = false;
      this.getList();
    },


    //显示责任人 和添加修改和删除 
    showInfo(id) {
      this.community_id = id;
      this.$nextTick(() => {
        this.info_visible = true;
      });
    },


    //删除
    del(id) {
      this.$confirm("确定删除该条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$_invoke(`communitySector_del`, { id }).then(() => {
            this.$_msg.success("删除成功");
            this.getList();
          });
        })
        .catch(() => { });
    },
  },
};
</script>
